import { memo } from 'react';

import Link from '@Navigation/Link';
import Img from '@UI/Img';
import styles from './MiniBanner.module.css';

import type { MouseEvent } from 'react';
import type { MainMenuItem } from '@Types/Layout';

export interface MiniBannerProps {
  miniBanner: MainMenuItem;
  onClick: (e: MouseEvent, miniBanner: MainMenuItem) => void;
}

const DEFAULT_ICON_SIZE_WIDTH = 54;
const DEFAULT_ICON_SIZE_HEIGHT = 46;

const MiniBanner = ({ miniBanner, onClick }: MiniBannerProps) => {
  return (
    <Link
      className={styles.bannerContainer}
      style={{ background: miniBanner.parameters?.backgroundColor }}
      to={miniBanner.url}
      onClick={(e) => onClick(e, miniBanner)}
    >
      <div className={styles.bannerContent}>
        <div className={styles.bannerText}>
          <div className={styles.bannerName}>{miniBanner.name}</div>
          <div className={styles.bannerDescription}>{miniBanner.subtitle}</div>
        </div>
        <div
          style={{
            width: `${miniBanner.parameters?.iconSize?.width || DEFAULT_ICON_SIZE_WIDTH}px`,
            height: `${miniBanner.parameters?.iconSize?.height || DEFAULT_ICON_SIZE_HEIGHT}px`,
            flex: `0 0 ${miniBanner.parameters?.iconSize?.width || DEFAULT_ICON_SIZE_WIDTH}px`,
          }}
        >
          <Img src={miniBanner.icon?.url} className={styles.bannerIcon} alt='banner-icon' />
        </div>
      </div>
      {miniBanner.parameters?.linkText && (
        <div className={styles.bannerButton}>{miniBanner.parameters.linkText}</div>
      )}
    </Link>
  );
};

export default memo(MiniBanner);
